module.exports = __webpack_public_path__ + "media/country_flags/kr-7032aecc.png";